import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { TableOutlined } from '@vicons/antd';
import { renderIcon } from '@/utils/index';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/video_review_scene',
    name: 'video_review_scene',
    redirect: '/video_review_scene/index',
    component: Layout,
    meta: {
      title: '分镜视频运营',
      icon: renderIcon(TableOutlined),
      sort: 71,
    },
    children: [
      {
        path: 'index',
        name: 'video_review_scene_index',
        meta: {
          title: '分镜视频运营',
        },
        component: () => import('@/views/video-review-scene/index.vue'),
      },
    ],
  },
];

export default routes;

